/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "components/MKBox";

// Material Kit 2 React examples
import DefaultInfoCard from "examples/Cards/InfoCards/DefaultInfoCard";

function CEOInformation() {
  return (
    <MKBox component="section" py={12}>
      <Container>
        <Grid container spacing={3} alignItems="center">
          <Grid item xs={12} lg={12} sx={{ ml: "auto", mt: { xs: 3, lg: 0 } }}>
            <DefaultInfoCard
              icon="info"
              title="Chief Electoral Officer of Nova Scotia"
              description={
                <>
                  <h4>Dorothy Rice Appointed Chief Electoral Officer</h4>
                  <br />
                  On November 8, 2022, the House of Assembly approved the appointment of Dorothy Rice as the Chief Electoral Officer (CEO) for the Province of Nova Scotia for a term of 10 years.
                  <br />
                  <br />
                  Ms. Rice had been a valued member of the ENS senior leadership team since 2011, serving as the Chief Financial Officer. She is a chartered professional accountant (CPA) and recipient of the profession&#39;s highest mark of distinction, the fellow (FCPA) designation. Over the next years, she will lead ENS through its new strategic plan. The plan lays out five commitments focused on improving electoral services for Nova Scotians, building relationships with stakeholders and partners, and supporting election workers.
                  <br />
                  <br />
                  <h4>The Role of Chief Electoral Officer</h4>
                  <br />
                  As head of Elections Nova Scotia, the CEO is accountable to the House of Assembly. The CEO provides independent, non-partisan, strategic advice on election-related matters and best practices in accordance with the terms of the <a href="https://nslegislature.ca/sites/default/files/legc/statutes/elections.pdf"><i><b><u>Elections Act</u></b></i></a>, and relevant laws. The CEO supervises the conduct of elections and provides leadership on other Elections Nova Scotia programs, services, operations and infrastructure.
                  <br />
                  The CEO administers provincial general elections and by-elections and keeps voters and candidates aware of their rights and responsibilities. It is the CEO’s responsibility to ensure that election officers act with fairness and impartiality, and in compliance with election laws (<a href="https://nslegislature.ca/sites/default/files/legc/statutes/elections.pdf"><i><b><u>Elections Act</u></b></i></a>, and <a href="https://nslegislature.ca/sites/default/files/legc/statutes/house%20of%20assembly.pdf"><i><b><u>House of Assembly Act</u></b></i></a>). The CEO also receives annual statements from all recognized parties and their associations, regarding the political contributions they received and the tax receipts they issued.
                  <br />
                  <br />
                  During a provincial general or by-election, the CEO has specific powers to:
                  <br />
                  <ul style={{ paddingLeft: "40px" }}>
                    <li >Extend the time for completing various tasks under the legislation; however, the CEO cannot extend the time for accepting nominations or the times for the opening and closing of the advance or ordinary polls</li>
                    <li>Prescribe and modify forms to suit existing circumstances</li>
                    <li>Remove from office any election officer who is not performing the duties of office satisfactorily, or who is showing a preference for one party over another</li>
                    <li>Appoint Returning Officers</li>
                    <li>Generally adapt the provisions of the <a href="https://nslegislature.ca/sites/default/files/legc/statutes/elections.pdf"><i><b><u>Elections Act</u></b></i></a> to fit the circumstances</li>
                  </ul>
                </>
              }
            />
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default CEOInformation;
